import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-service-catalog",
  templateUrl: "./service-catalog.component.html",
  styleUrls: ["./service-catalog.component.css"],
})
export class ServiceCatalogComponent implements OnInit, OnDestroy {
  selectedService: "ec2" | "eks" = "ec2";

  private queryParamSubscription: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.queryParamSubscription = this.route.queryParamMap.subscribe((params) => {
      const service = (params.get("service") || "").toLowerCase();
      if (service === "eks" || service === "ec2") {
        this.selectedService = service as "ec2" | "eks";
      }
    });
  }

  ngOnDestroy(): void {
    if (this.queryParamSubscription) this.queryParamSubscription.unsubscribe();
  }
}

